import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'

export default {
	/**
	 * 用户列表接口
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	userList( params={} ) {
		return request({
	    url: baseUrl + '/auth/admins',
	    method: 'GET',
	    params
	  })
	},
	/**
	 * 用户添加接口
	**/
    userAdd(data) {
		return request({
	    url: baseUrl + '/auth/admins',
	    method: 'POST',
	    data
	  })
	},
	/**
	 * 用户编辑接口 若修改密码只需传入password字段 修改信息则无需传入
	**/
	userEdit(id,data){
		return request({
			url: baseUrl + '/auth/admins/'+id,
			method:'PUT',
			data
		})
	},
	/**
	 * 删除用户接口
	**/
	userDel(id){
		return request({
			url: baseUrl + '/auth/admins/'+id,
			method:'DELETE'
		})
	},
	/**
	 * 权限组列表
	**/
	getNodeTree() {
		return request({
	    url: baseUrl + '/auth/node',
	    method: 'GET'
	  })
	},

	/**
	 * 获取用户基础数据配置
	**/
	getSystemBase(id) {
		return request({
	    url: baseUrl + '/auth/getSystem/'+id,
	    method: 'GET'
	  })
	},
	/**
	 * 修改用户基础数据配置
	**/
	EditSystemBase(id,data){
		return request({
	    url: baseUrl + '/auth/system/'+id,
	    method:'PUT',
		data
	  })
	},


	/**
	 * 获取账号绑定设备列表数据
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	userDeviceList(id,params) {
		return request({
	    url: baseUrl + '/auth/getDistribution/'+id,
	    method: 'GET',
	    params
	  })
	},
	/**
	 * 用户添加账号绑定设备
	**/
    userDeviceAdd(data) {
		return request({
	    url: baseUrl + '/auth/distribution',
	    method: 'POST',
	    data
	  })
	},
	/**
	 * 编辑用户账号绑定设备
	**/
	userDeviceEdit(id,data){
		return request({
			url: baseUrl + '/auth/distribution/'+id,
			method:'PUT',
			data
		})
	},
	/**
	 * 删除用户账号绑定设备
	**/
	userDeviceDel(id){
		return request({
			url: baseUrl + '/auth/distribution/'+id,
			method:'DELETE'
		})
	},
}